// DialogLogout component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../layout/dialog/dialog.jsx'
import Button from '../../common/button/button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class DialogAlert extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string,
      message: PropTypes.string,
      onOk: PropTypes.func,
      onCancel: PropTypes.func,
      onSwitchAccount: PropTypes.func,
      showSwitchAccount: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      title: '',
      message: '',
      onOk: null,
      onCancel: null,
      onSwitchAccount: null,
      showSwitchAccount: false
    }
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({ active: false })
  }

  render () {
    const showSwitchAccount = this.props.showSwitchAccount
    const footerClass = showSwitchAccount
      ? 'actionboard-footer alt'
      : 'actionboard-footer'
    return (
      <Dialog
        active={this.state.active}
        onClose={this._onClickCancel.bind(this)}
        modal
      >
        <div className='dialog-actionboard'>
          <div className='actionboard-section'>
            <div className='actionboard-row'>
              <div className='actionboard-col'>
                <div className='title'>
                  <IntlMessage ident={this.props.title} />
                </div>
                <div className='msg'>
                  <IntlMessage ident={this.props.message} />
                </div>
              </div>
            </div>
          </div>
          <div className={footerClass}>
            <div className='actionboard-row alert-row'>
              <div className='actionboard-col3 alert-col3'>
                <div
                  className='action-btn'
                  onClick={this._onClickOk.bind(this)}
                  data-testid='logout-confirm'
                >
                  <Button
                    icon='logout-confirm-success'
                    className='button_dialog'
                    canHover={false}
                  />
                  <span className='label'>
                    <IntlMessage ident='common.dialogLogout.labelOk' />
                  </span>
                </div>
              </div>
              <div className='actionboard-col3 alert-col3'>
                <div
                  className='action-btn'
                  onClick={this._onClickCancel.bind(this)}
                >
                  <Button
                    icon='logout-confirm-close'
                    className='button_dialog'
                    canHover={false}
                  />
                  <span className='label'>
                    <IntlMessage ident='common.dialogLogout.labelCancel' />
                  </span>
                </div>
              </div>
              {showSwitchAccount && (
                <div className='actionboard-col3 alert-col3'>
                  <div
                    className='action-btn'
                    onClick={this._onClickSwitchAccount.bind(this)}
                  >
                    <Button
                      icon='logout-switchaccount'
                      className='button_dialog'
                      canHover={false}
                    />
                    <span className='label'>
                      <IntlMessage ident='common.dialogLogout.labelSwitchAccount' />
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Private Functions */
  _onClickOk (ev) {
    ev.preventDefault()
    this.hide()

    if (this.props.onOk) {
      this.props.onOk(ev)
    }
  }

  _onClickCancel (ev) {
    if (ev) {
      ev.preventDefault()
    }

    this.hide()

    if (this.props.onCancel) {
      this.props.onCancel()
    }
  }

  _onClickSwitchAccount (ev) {
    ev.preventDefault()
    this.hide()

    if (this.props.onSwitchAccount) {
      this.props.onSwitchAccount(ev)
    }
  }
}

export default DialogAlert
